import { render, staticRenderFns } from "./Worker.vue?vue&type=template&id=42ffe74a&scoped=true"
import script from "./Worker.vue?vue&type=script&lang=js"
export * from "./Worker.vue?vue&type=script&lang=js"
import style0 from "./Worker.vue?vue&type=style&index=0&id=42ffe74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ffe74a",
  null
  
)

export default component.exports